import { render, staticRenderFns } from "./PopupSettings.vue?vue&type=template&id=7df70b27"
import script from "./PopupSettings.vue?vue&type=script&lang=js"
export * from "./PopupSettings.vue?vue&type=script&lang=js"
import style0 from "./PopupSettings.vue?vue&type=style&index=0&id=7df70b27&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports